import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    performanceValue: '',
    error: null,
}

const overallPerformance = createSlice({
    name: 'overallPerformance',
    initialState: initialState,
    reducers: {
        updatePerformance(state, action) {
            state.performanceValue = action.payload
        },
        resetOverallPerformanceState(state) {
            state.performanceValue = '';
            state.isLoading = false;
            state.error = null;
        },
    },
});

export const { updatePerformance, resetOverallPerformanceState } = overallPerformance.actions;

export default overallPerformance.reducer;
